import { render, staticRenderFns } from "./AlarmPointSelect.vue?vue&type=template&id=d8c9d9c2&scoped=true"
import script from "./AlarmPointSelect.vue?vue&type=script&lang=ts"
export * from "./AlarmPointSelect.vue?vue&type=script&lang=ts"
import style0 from "./AlarmPointSelect.vue?vue&type=style&index=0&id=d8c9d9c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c9d9c2",
  null
  
)

export default component.exports